// Simplified routes for WhatsApp CMS
import React from 'react';
import {Navigate} from 'react-router-dom';
import {initialUrl, RoutePermittedRole} from 'shared/constants/AppConst';

import {authRouteConfig} from './auth';
import {errorPagesConfigs} from './errorPages';
import {homeConfig} from './home';
import {usersConfig} from './users';
import {muraasalaRoutesConfig} from './muraasala/routes';

// Account pages
const ProfilePage = React.lazy(() => import('./account/ProfilePage'));
const SettingsPage = React.lazy(() => import('./account/SettingsPage'));

const accountPagesConfig = [
  {
    permittedRole: RoutePermittedRole.user,
    path: '/account/profile',
    element: <ProfilePage />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/account/settings',
    element: <SettingsPage />,
  },
];

// Role-based redirect for root path
const RoleBasedRedirect = React.lazy(() => import('./home/RoleBasedRedirect'));

const authorizedStructure = {
  fallbackPath: '/signin',
  routes: [
    // Root redirect for authenticated users
    {
      permittedRole: RoutePermittedRole.user,
      path: '/',
      element: <RoleBasedRedirect />,
    },
    ...homeConfig,
    ...usersConfig,
    ...muraasalaRoutesConfig,
    ...accountPagesConfig,
  ],
};

const unAuthorizedStructure = {
  fallbackPath: initialUrl,
  routes: authRouteConfig,
};

// Password reset routes must be in anonymousStructure so authenticated users
// can still access them (unAuthorizedStructure redirects logged-in users away).
const ForgotPassword = React.lazy(() => import('./auth/ForgotPassword'));
const ResetPassword = React.lazy(() => import('./auth/ResetPassword'));

const anonymousStructure = {
  routes: errorPagesConfigs.concat([
    {path: '/forgot-password', element: <ForgotPassword />},
    {path: '/reset-password', element: <ResetPassword />},
    {path: '/', element: <Navigate to='/signin' />},
    {path: '*', element: <Navigate to='/error-pages/error-404' />},
  ]),
};

export {authorizedStructure, unAuthorizedStructure, anonymousStructure};
export default {authorizedStructure, unAuthorizedStructure, anonymousStructure};
